import { useContext } from "react";

import { PlayerStoreContext, PlayerStoreWithSelectors } from "./store";

export const usePlayerStore = (): PlayerStoreWithSelectors => {
  const store = useContext(PlayerStoreContext);
  if (!store) {
    throw new Error("Missing PlayerStoreContext.Provider in the tree");
  }
  return store;
};
